module.exports = __webpack_public_path__ + "img/winnings-heti.ead93e91.png";